var _IconDelete;
// import Modules
import Box from '@mui/material/Box';
import React from 'react';
import colors from "../../theme/colors";
import Typography from "../../atoms/Typography";
import { IconDelete } from "../../atoms/Icon";
import DropdownQuantity from "../DropdownQuantity";
import useMediaQuery from '@mui/material/useMediaQuery';

// import Types
import { formatCurrency, formatCurrencyForTcKo } from "../../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const QuantityCard = props => {
  const {
    id,
    mainImageNext,
    mainImage = '',
    title,
    edition,
    platform,
    originalPrice,
    promoPrice,
    quantity = 1,
    onClickDelete = () => {},
    onSetQuantity = () => {},
    freegift,
    variant = 'quantity',
    productId,
    helperText,
    colorHelperText,
    setMaxQuantity = 5,
    currencySymbol = 'S$',
    nextLink,
    href = "",
    textQuantity,
    locale
  } = props;
  const isMobile = useMediaQuery(themes => themes.breakpoints.down('md'));
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%'
    },
    children: [typeof nextLink === "function" ? nextLink(href, /*#__PURE__*/_jsx(Box, {
      sx: {
        width: {
          xs: '90px',
          md: '168px'
        },
        minWidth: {
          xs: '90px',
          md: '168px'
        },
        height: {
          xs: '90px',
          md: '168px'
        },
        borderRadius: '10px',
        overflow: "hidden",
        transform: 'rotate(0)',
        "& span": {
          height: "100% !important",
          width: "100% !important"
        },
        '& img': {
          objectFit: 'cover',
          display: 'block',
          width: '100%',
          height: '100%',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: "scale(1.2)"
          }
        }
      },
      children: mainImageNext || /*#__PURE__*/_jsx("img", {
        src: mainImage,
        alt: mainImage ?? ''
      })
    })) : /*#__PURE__*/_jsx(Box, {
      sx: {
        width: {
          xs: '90px',
          md: '168px'
        },
        minWidth: {
          xs: '90px',
          md: '168px'
        },
        height: {
          xs: '90px',
          md: '168px'
        },
        borderRadius: '10px',
        overflow: "hidden",
        transform: 'rotate(0)',
        "& span": {
          height: "100% !important",
          width: "100% !important"
        },
        '& img': {
          objectFit: 'cover',
          display: 'block',
          width: '100%',
          height: '100%',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: "scale(1.2)"
          }
        }
      },
      children: mainImageNext || /*#__PURE__*/_jsx("img", {
        src: mainImage,
        alt: mainImage ?? ''
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: '100%',
        marginLeft: {
          xs: '16px',
          md: '22px'
        },
        alignItems: 'left',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: {
          xs: 'flex-start',
          md: 'center'
        }
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'baseline',
            "& a": {
              textDecoration: "none"
            }
          },
          children: [typeof nextLink === "function" ? nextLink(href, /*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            sx: {
              color: colors.primary.bandaiNamcoBlack,
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              wordBreak: "break-word"
            },
            children: title
          })) : /*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            sx: {
              color: colors.primary.bandaiNamcoBlack,
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              wordBreak: "break-word"
            },
            children: title
          }), variant === 'quantity' && /*#__PURE__*/_jsx(Box, {
            onClick: () => onClickDelete(id),
            sx: {
              cursor: 'pointer',
              '& svg': {
                width: '14px',
                height: '16px'
              }
            },
            children: _IconDelete || (_IconDelete = /*#__PURE__*/_jsx(IconDelete, {}))
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '4px',
              md: '10px'
            },
            marginTop: {
              xs: '8px',
              md: '10px'
            },
            marginBottom: {
              xs: '12px',
              md: '32px'
            }
          },
          children: [platform && /*#__PURE__*/_jsx(Typography, {
            variant: "p7",
            sx: {
              color: colors.neutral.neutral2,
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              wordBreak: "break-word"
            },
            children: platform
          }), edition && /*#__PURE__*/_jsx(Typography, {
            variant: "p7",
            sx: {
              color: colors.neutral.neutral2,
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              wordBreak: "break-word"
            },
            children: edition
          })]
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            '& .MuiFormControl-root': {
              width: {
                xs: '94px',
                md: '123px'
              },
              height: {
                xs: '41px',
                md: '47px'
              },
              '& .MuiSelect-select': {
                padding: '10.5px 20px 14.5px !important'
              }
            }
          },
          children: /*#__PURE__*/_jsx(DropdownQuantity, {
            maxQuantity: setMaxQuantity,
            label: textQuantity,
            currentQuantity: quantity,
            disableSelect: variant === 'freegifts',
            onSetQuantity: selectedNumber => onSetQuantity(id, selectedNumber, productId)
          })
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: {
              md: 'center'
            },
            gap: {
              xs: '2px',
              md: '12px'
            },
            flexDirection: {
              xs: 'column',
              md: 'row'
            }
          },
          children: [promoPrice && /*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            color: colors.primary.dark,
            children:
            // eslint-disable-next-line no-nested-ternary
            ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(promoPrice * quantity)}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(promoPrice * quantity)}${currencySymbol}` : `${currencySymbol}${formatCurrency(promoPrice * quantity, 2)}`
          }), originalPrice && /*#__PURE__*/_jsx(Typography, {
            variant: promoPrice ? 'l2' : 'h6',
            color: promoPrice ? colors.neutral.neutral2 : colors.primary.dark,
            sx: {
              textDecoration: promoPrice ? 'line-through' : 'none'
            },
            children:
            // eslint-disable-next-line no-nested-ternary
            ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(originalPrice * quantity)}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(originalPrice * quantity)}${currencySymbol}` : `${currencySymbol}${formatCurrency(originalPrice * quantity, 2)}`
          }), freegift && /*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            color: colors.primary.bandaiNamcoBlack,
            sx: {},
            children: freegift
          })]
        })]
      }), helperText && /*#__PURE__*/_jsx(Typography, {
        variant: isMobile ? 'p8' : 'p9',
        color: colorHelperText === 'neutral2' ? colors.neutral.neutral2 : colors.primary.bandaiNamcoRed,
        sx: {
          marginTop: '4px',
          fontSize: '12px',
          maxWidth: {
            xs: '94px',
            sm: '100%'
          },
          lineHeight: {
            xs: '18px',
            md: '16px'
          }
        },
        children: helperText
      })]
    })]
  });
};
export default QuantityCard;